"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getUser = getUser;
exports.getCurrentUser = getCurrentUser;
exports.loginAlreadyUsedAsync = loginAlreadyUsedAsync;
exports.saveUserAsync = saveUserAsync;
exports.getAccounts = getAccounts;
exports.updateAccounts = updateAccounts;
exports.linkExistingAccountWithLogin = linkExistingAccountWithLogin;
exports.linkExistingAccountWithBluid = linkExistingAccountWithBluid;
exports.savePassword = savePassword;
exports.verifyNewPassword = verifyNewPassword;
exports.loadPasswordRules = loadPasswordRules;
exports.getLinkedAccounts = getLinkedAccounts;
exports.getActiveLinkedAccounts = getActiveLinkedAccounts;
exports.getActiveOnvioLinkedAccounts = getActiveOnvioLinkedAccounts;
exports.getAllOnvioLinkedAccounts = getAllOnvioLinkedAccounts;
exports.getActiveOnbalanceLinkedAccounts = getActiveOnbalanceLinkedAccounts;
exports.getAllOnbalanceLinkedAccounts = getAllOnbalanceLinkedAccounts;

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _environment = require("../environment");

var _session = require("../session");

var _interceptor = require("../session/interceptor");

var _utils = require("../utils");

var _internals = require("../utils/internals");

function normalizeUserModel(user) {
  return {
    email: user.email,
    firstName: user.firstName,
    language: user.language,
    lastName: user.lastName,
    middleName: user.middleName ? user.middleName : '',
    prefix: user.prefix ? user.prefix : '',
    suffix: user.suffix ? user.suffix : '',
    photo: user.photo
  };
}

function getUser(_x) {
  return _getUser.apply(this, arguments);
}

function _getUser() {
  _getUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(blueID) {
    return _regenerator.default.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context;

              return (0, _concat.default)(_context = "".concat(base, "/v1/users/")).call(_context, blueID);
            }).then( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
                return _regenerator.default.wrap(function _callee$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x11) {
                return _ref2.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(response) {
                return _regenerator.default.wrap(function _callee2$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x12) {
                return _ref3.apply(this, arguments);
              };
            }()).then(function (user) {
              return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, user), {}, {
                blueID: blueID
              });
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3);
  }));
  return _getUser.apply(this, arguments);
}

function getCurrentUser() {
  return _getCurrentUser.apply(this, arguments);
}

function _getCurrentUser() {
  _getCurrentUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
    return _regenerator.default.wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", (0, _session.get)().then( /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(_ref4) {
                var meta, bindings;
                return _regenerator.default.wrap(function _callee4$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        meta = _ref4.meta, bindings = _ref4.bindings;
                        return _context5.abrupt("return", getUser(meta.PrismGuid).then(function (user) {
                          var _user$blueID, _user$companyId;

                          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, user), {}, {
                            blueID: (_user$blueID = user.blueID) !== null && _user$blueID !== void 0 ? _user$blueID : meta.PrismGuid,
                            companyId: (_user$companyId = user.companyId) !== null && _user$companyId !== void 0 ? _user$companyId : bindings.ApplicationConfiguration.CompanyId
                          });
                        }));

                      case 2:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x13) {
                return _ref5.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee5);
  }));
  return _getCurrentUser.apply(this, arguments);
}

function loginAlreadyUsedAsync(_x2) {
  return _loginAlreadyUsedAsync.apply(this, arguments);
}

function _loginAlreadyUsedAsync() {
  _loginAlreadyUsedAsync = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(email) {
    return _regenerator.default.wrap(function _callee9$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", (0, _session.getMeta)().then( /*#__PURE__*/function () {
              var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(meta) {
                return _regenerator.default.wrap(function _callee8$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        if (!(meta.EmailAddress && email && email.toLowerCase() === meta.EmailAddress.toLowerCase())) {
                          _context10.next = 2;
                          break;
                        }

                        return _context10.abrupt("return", _promise.default.resolve({
                          results: 'notfound'
                        }));

                      case 2:
                        return _context10.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
                          var _context7;

                          return (0, _concat.default)(_context7 = "".concat(base, "/v1/users/login-in-use?login=")).call(_context7, encodeURIComponent(email));
                        }).then( /*#__PURE__*/function () {
                          var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(url) {
                            return _regenerator.default.wrap(function _callee6$(_context8) {
                              while (1) {
                                switch (_context8.prev = _context8.next) {
                                  case 0:
                                    return _context8.abrupt("return", fetch(url, {
                                      headers: (0, _utils.jsonHeaders)()
                                    }));

                                  case 1:
                                  case "end":
                                    return _context8.stop();
                                }
                              }
                            }, _callee6);
                          }));

                          return function (_x15) {
                            return _ref7.apply(this, arguments);
                          };
                        }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
                          var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(response) {
                            return _regenerator.default.wrap(function _callee7$(_context9) {
                              while (1) {
                                switch (_context9.prev = _context9.next) {
                                  case 0:
                                    return _context9.abrupt("return", response.json());

                                  case 1:
                                  case "end":
                                    return _context9.stop();
                                }
                              }
                            }, _callee7);
                          }));

                          return function (_x16) {
                            return _ref8.apply(this, arguments);
                          };
                        }()));

                      case 3:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee8);
              }));

              return function (_x14) {
                return _ref6.apply(this, arguments);
              };
            }()).then(function (_ref9) {
              var results = _ref9.results;
              return results === 'found';
            }));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee9);
  }));
  return _loginAlreadyUsedAsync.apply(this, arguments);
}

function saveUserAsync(_x3) {
  return _saveUserAsync.apply(this, arguments);
}

function _saveUserAsync() {
  _saveUserAsync = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(user) {
    return _regenerator.default.wrap(function _callee13$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            user = normalizeUserModel(user);
            return _context16.abrupt("return", (0, _session.getMeta)().then( /*#__PURE__*/function () {
              var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(_ref10) {
                var _user$email;

                var PrismGuid;
                return _regenerator.default.wrap(function _callee10$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        PrismGuid = _ref10.PrismGuid;

                        if (PrismGuid) {
                          _context12.next = 3;
                          break;
                        }

                        throw new Error('bm.account.service.unableToLoadUser');

                      case 3:
                        return _context12.abrupt("return", _promise.default.all([PrismGuid, loginAlreadyUsedAsync((_user$email = user.email) !== null && _user$email !== void 0 ? _user$email : '')]));

                      case 4:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee10);
              }));

              return function (_x17) {
                return _ref11.apply(this, arguments);
              };
            }()).then( /*#__PURE__*/function () {
              var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(_ref12) {
                var _ref14, PrismGuid, isUsed;

                return _regenerator.default.wrap(function _callee12$(_context15) {
                  while (1) {
                    switch (_context15.prev = _context15.next) {
                      case 0:
                        _ref14 = (0, _slicedToArray2.default)(_ref12, 2), PrismGuid = _ref14[0], isUsed = _ref14[1];

                        if (!isUsed) {
                          _context15.next = 3;
                          break;
                        }

                        throw new Error('BM.Components.EmailInUseError');

                      case 3:
                        return _context15.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
                          var _context13;

                          return (0, _concat.default)(_context13 = "".concat(base, "/v1/users/")).call(_context13, PrismGuid);
                        }).then( /*#__PURE__*/function () {
                          var _ref15 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(url) {
                            return _regenerator.default.wrap(function _callee11$(_context14) {
                              while (1) {
                                switch (_context14.prev = _context14.next) {
                                  case 0:
                                    return _context14.abrupt("return", fetch(url, {
                                      body: (0, _stringify.default)(user),
                                      headers: (0, _utils.jsonHeaders)(),
                                      method: 'PUT'
                                    }));

                                  case 1:
                                  case "end":
                                    return _context14.stop();
                                }
                              }
                            }, _callee11);
                          }));

                          return function (_x19) {
                            return _ref15.apply(this, arguments);
                          };
                        }()));

                      case 4:
                      case "end":
                        return _context15.stop();
                    }
                  }
                }, _callee12);
              }));

              return function (_x18) {
                return _ref13.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower));

          case 2:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee13);
  }));
  return _saveUserAsync.apply(this, arguments);
}

function getAccounts(_x4) {
  return _getAccounts.apply(this, arguments);
}

function _getAccounts() {
  _getAccounts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(_ref) {
    var _ref$active, active, _ref$onlyOnvio, onlyOnvio;

    return _regenerator.default.wrap(function _callee16$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _ref$active = _ref.active, active = _ref$active === void 0 ? true : _ref$active, _ref$onlyOnvio = _ref.onlyOnvio, onlyOnvio = _ref$onlyOnvio === void 0 ? true : _ref$onlyOnvio;
            return _context19.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var url = new _url.default("".concat(base, "/v1/accounts"));

              if (active !== null) {
                url.searchParams.append('active', String(active));
              }

              if (onlyOnvio !== null) {
                url.searchParams.append('hideNonOnvio', String(onlyOnvio));
              }

              return url.href;
            }).then( /*#__PURE__*/function () {
              var _ref16 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(url) {
                return _regenerator.default.wrap(function _callee14$(_context17) {
                  while (1) {
                    switch (_context17.prev = _context17.next) {
                      case 0:
                        return _context17.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context17.stop();
                    }
                  }
                }, _callee14);
              }));

              return function (_x20) {
                return _ref16.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref17 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15(response) {
                return _regenerator.default.wrap(function _callee15$(_context18) {
                  while (1) {
                    switch (_context18.prev = _context18.next) {
                      case 0:
                        return _context18.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context18.stop();
                    }
                  }
                }, _callee15);
              }));

              return function (_x21) {
                return _ref17.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee16);
  }));
  return _getAccounts.apply(this, arguments);
}

function updateAccounts(_x5) {
  return _updateAccounts.apply(this, arguments);
}

function _updateAccounts() {
  _updateAccounts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(accounts) {
    return _regenerator.default.wrap(function _callee19$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            return _context22.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              return "".concat(base, "/v1/accounts");
            }).then( /*#__PURE__*/function () {
              var _ref18 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(url) {
                return _regenerator.default.wrap(function _callee17$(_context20) {
                  while (1) {
                    switch (_context20.prev = _context20.next) {
                      case 0:
                        return _context20.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)(accounts),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'PUT'
                        }));

                      case 1:
                      case "end":
                        return _context20.stop();
                    }
                  }
                }, _callee17);
              }));

              return function (_x22) {
                return _ref18.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18(response) {
                return _regenerator.default.wrap(function _callee18$(_context21) {
                  while (1) {
                    switch (_context21.prev = _context21.next) {
                      case 0:
                        return _context21.abrupt("return", response.ok ? _promise.default.resolve({}) : response.json());

                      case 1:
                      case "end":
                        return _context21.stop();
                    }
                  }
                }, _callee18);
              }));

              return function (_x23) {
                return _ref19.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee19);
  }));
  return _updateAccounts.apply(this, arguments);
}

function linkExistingAccountWithLogin(_x6) {
  return _linkExistingAccountWithLogin.apply(this, arguments);
}

function _linkExistingAccountWithLogin() {
  _linkExistingAccountWithLogin = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(email) {
    return _regenerator.default.wrap(function _callee22$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            return _context26.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context23;

              return (0, _concat.default)(_context23 = "".concat(base, "/v1/accounts/merge?login=")).call(_context23, encodeURIComponent(email));
            }).then( /*#__PURE__*/function () {
              var _ref20 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(url) {
                return _regenerator.default.wrap(function _callee20$(_context24) {
                  while (1) {
                    switch (_context24.prev = _context24.next) {
                      case 0:
                        return _context24.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'PUT'
                        }));

                      case 1:
                      case "end":
                        return _context24.stop();
                    }
                  }
                }, _callee20);
              }));

              return function (_x24) {
                return _ref20.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21(response) {
                return _regenerator.default.wrap(function _callee21$(_context25) {
                  while (1) {
                    switch (_context25.prev = _context25.next) {
                      case 0:
                        return _context25.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context25.stop();
                    }
                  }
                }, _callee21);
              }));

              return function (_x25) {
                return _ref21.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee22);
  }));
  return _linkExistingAccountWithLogin.apply(this, arguments);
}

function linkExistingAccountWithBluid(_x7) {
  return _linkExistingAccountWithBluid.apply(this, arguments);
}

function _linkExistingAccountWithBluid() {
  _linkExistingAccountWithBluid = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee25(bluid) {
    return _regenerator.default.wrap(function _callee25$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            return _context30.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context27;

              return (0, _concat.default)(_context27 = "".concat(base, "/v1/accounts/merge/")).call(_context27, bluid);
            }).then( /*#__PURE__*/function () {
              var _ref22 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(url) {
                return _regenerator.default.wrap(function _callee23$(_context28) {
                  while (1) {
                    switch (_context28.prev = _context28.next) {
                      case 0:
                        return _context28.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'PUT'
                        }));

                      case 1:
                      case "end":
                        return _context28.stop();
                    }
                  }
                }, _callee23);
              }));

              return function (_x26) {
                return _ref22.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref23 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee24(response) {
                return _regenerator.default.wrap(function _callee24$(_context29) {
                  while (1) {
                    switch (_context29.prev = _context29.next) {
                      case 0:
                        return _context29.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context29.stop();
                    }
                  }
                }, _callee24);
              }));

              return function (_x27) {
                return _ref23.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee25);
  }));
  return _linkExistingAccountWithBluid.apply(this, arguments);
}

function savePassword(_x8, _x9) {
  return _savePassword.apply(this, arguments);
}

function _savePassword() {
  _savePassword = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee28(oldPassword, newPassword) {
    return _regenerator.default.wrap(function _callee28$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            return _context34.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context31;

              return (0, _concat.default)(_context31 = "".concat(base, "/v1/password?")).call(_context31, _interceptor.preventOnUnauthorizedHeader);
            }).then( /*#__PURE__*/function () {
              var _ref24 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee26(url) {
                return _regenerator.default.wrap(function _callee26$(_context32) {
                  while (1) {
                    switch (_context32.prev = _context32.next) {
                      case 0:
                        return _context32.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)({
                            oldPassword: oldPassword,
                            newPassword: newPassword
                          }),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'PUT'
                        }));

                      case 1:
                      case "end":
                        return _context32.stop();
                    }
                  }
                }, _callee26);
              }));

              return function (_x28) {
                return _ref24.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref25 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee27(response) {
                return _regenerator.default.wrap(function _callee27$(_context33) {
                  while (1) {
                    switch (_context33.prev = _context33.next) {
                      case 0:
                        return _context33.abrupt("return", response.ok ? _promise.default.resolve({}) : response.json());

                      case 1:
                      case "end":
                        return _context33.stop();
                    }
                  }
                }, _callee27);
              }));

              return function (_x29) {
                return _ref25.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee28);
  }));
  return _savePassword.apply(this, arguments);
}

function verifyNewPassword(_x10) {
  return _verifyNewPassword.apply(this, arguments);
}

function _verifyNewPassword() {
  _verifyNewPassword = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee31(password) {
    return _regenerator.default.wrap(function _callee31$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            return _context37.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              return "".concat(base, "/v2/password/check");
            }).then( /*#__PURE__*/function () {
              var _ref26 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee29(url) {
                return _regenerator.default.wrap(function _callee29$(_context35) {
                  while (1) {
                    switch (_context35.prev = _context35.next) {
                      case 0:
                        return _context35.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)({
                            password: password
                          }),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'POST'
                        }));

                      case 1:
                      case "end":
                        return _context35.stop();
                    }
                  }
                }, _callee29);
              }));

              return function (_x30) {
                return _ref26.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref27 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee30(response) {
                return _regenerator.default.wrap(function _callee30$(_context36) {
                  while (1) {
                    switch (_context36.prev = _context36.next) {
                      case 0:
                        return _context36.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context36.stop();
                    }
                  }
                }, _callee30);
              }));

              return function (_x31) {
                return _ref27.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee31);
  }));
  return _verifyNewPassword.apply(this, arguments);
}

var passwordInvalidCharacters = /[^a-zA-Z0-9`~/\\[\]+=|(){}:;'"<>,.?!@#$%^&*\-_¡¢£¤¥´ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/;

function loadPasswordRules() {
  return _loadPasswordRules.apply(this, arguments);
}

function _loadPasswordRules() {
  _loadPasswordRules = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee36() {
    return _regenerator.default.wrap(function _callee36$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            return _context42.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              return "".concat(base, "/v2/password/rules");
            }).then( /*#__PURE__*/function () {
              var _ref28 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee32(url) {
                return _regenerator.default.wrap(function _callee32$(_context38) {
                  while (1) {
                    switch (_context38.prev = _context38.next) {
                      case 0:
                        return _context38.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context38.stop();
                    }
                  }
                }, _callee32);
              }));

              return function (_x32) {
                return _ref28.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref29 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee33(response) {
                return _regenerator.default.wrap(function _callee33$(_context39) {
                  while (1) {
                    switch (_context39.prev = _context39.next) {
                      case 0:
                        return _context39.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context39.stop();
                    }
                  }
                }, _callee33);
              }));

              return function (_x33) {
                return _ref29.apply(this, arguments);
              };
            }()).then(function (_ref30) {
              var classes = _ref30.classes,
                  chars = _ref30.chars;
              var serverRule = (0, _utils.debouncePromise)(verifyNewPassword, 200);
              return {
                charClassReq: Number(classes),
                charLengthReq: Number(chars),
                rules: [{
                  interpolation: {
                    val: chars
                  },
                  label: 'password.validation.characterRule',
                  test: function test(password) {
                    return Boolean(password) && password.length >= Number(chars);
                  }
                }, {
                  label: 'password.validation.numberRule',
                  test: function test(password) {
                    return Boolean(password) && /\d/.test(password);
                  }
                }, {
                  label: 'password.validation.lowerCaseRule',
                  test: function test(password) {
                    return Boolean(password) && /[a-z]/.test(password);
                  }
                }, {
                  label: 'password.validation.upperCaseRule',
                  test: function test(password) {
                    return Boolean(password) && /[A-Z]/.test(password);
                  }
                }, {
                  label: 'password.validation.specialCharactersRule',
                  test: function test(password) {
                    return Boolean(password) && /[`~!@#$£%^&*()_\-+={}[\]\\|:;"',.?/]+/.test(password);
                  }
                }, {
                  label: 'password.validation.prohibitedCharacters',
                  getInvalidChars: function getInvalidChars(password) {
                    var matches = new _set.default();
                    var pattern = /[^a-zA-Z0-9`~/\\[\]+=|(){}:;'"<>,.?!@#$%^&*\-_¡¢£¤¥´ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/g;
                    var match = pattern.exec(password);

                    while (match) {
                      matches.add(match[0]);
                      match = pattern.exec(password);
                    }

                    return (0, _toConsumableArray2.default)(matches);
                  },
                  test: function test(password) {
                    return Boolean(password) && !passwordInvalidCharacters.test(password);
                  }
                }],
                rulesAsync: [{
                  label: 'password.validation.used',
                  test: function () {
                    var _test = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee34(password) {
                      return _regenerator.default.wrap(function _callee34$(_context40) {
                        while (1) {
                          switch (_context40.prev = _context40.next) {
                            case 0:
                              return _context40.abrupt("return", serverRule(password).then(function (r) {
                                return !r.usedPreviously;
                              }));

                            case 1:
                            case "end":
                              return _context40.stop();
                          }
                        }
                      }, _callee34);
                    }));

                    function test(_x34) {
                      return _test.apply(this, arguments);
                    }

                    return test;
                  }()
                }, {
                  label: 'password.validation.blacklist',
                  test: function () {
                    var _test2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee35(password) {
                      return _regenerator.default.wrap(function _callee35$(_context41) {
                        while (1) {
                          switch (_context41.prev = _context41.next) {
                            case 0:
                              return _context41.abrupt("return", serverRule(password).then(function (r) {
                                return !r.tooCommon;
                              }));

                            case 1:
                            case "end":
                              return _context41.stop();
                          }
                        }
                      }, _callee35);
                    }));

                    function test(_x35) {
                      return _test2.apply(this, arguments);
                    }

                    return test;
                  }()
                }]
              };
            }));

          case 1:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee36);
  }));
  return _loadPasswordRules.apply(this, arguments);
}

function getLinkedAccounts() {
  return _getLinkedAccounts.apply(this, arguments);
}

function _getLinkedAccounts() {
  _getLinkedAccounts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee37() {
    return _regenerator.default.wrap(function _callee37$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            return _context43.abrupt("return", getAccounts({
              active: null,
              onlyOnvio: null
            }));

          case 1:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee37);
  }));
  return _getLinkedAccounts.apply(this, arguments);
}

function getActiveLinkedAccounts() {
  return _getActiveLinkedAccounts.apply(this, arguments);
}

function _getActiveLinkedAccounts() {
  _getActiveLinkedAccounts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee38() {
    return _regenerator.default.wrap(function _callee38$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            return _context44.abrupt("return", getAccounts({
              active: true,
              onlyOnvio: null
            }));

          case 1:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee38);
  }));
  return _getActiveLinkedAccounts.apply(this, arguments);
}

function getActiveOnvioLinkedAccounts() {
  return _getActiveOnvioLinkedAccounts.apply(this, arguments);
}

function _getActiveOnvioLinkedAccounts() {
  _getActiveOnvioLinkedAccounts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee39() {
    return _regenerator.default.wrap(function _callee39$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            return _context45.abrupt("return", getAccounts({
              active: true,
              onlyOnvio: true
            }));

          case 1:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee39);
  }));
  return _getActiveOnvioLinkedAccounts.apply(this, arguments);
}

function getAllOnvioLinkedAccounts() {
  return _getAllOnvioLinkedAccounts.apply(this, arguments);
}

function _getAllOnvioLinkedAccounts() {
  _getAllOnvioLinkedAccounts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee40() {
    return _regenerator.default.wrap(function _callee40$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            return _context46.abrupt("return", getAccounts({
              active: null,
              onlyOnvio: true
            }));

          case 1:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee40);
  }));
  return _getAllOnvioLinkedAccounts.apply(this, arguments);
}

function getActiveOnbalanceLinkedAccounts() {
  return _getActiveOnbalanceLinkedAccounts.apply(this, arguments);
}

function _getActiveOnbalanceLinkedAccounts() {
  _getActiveOnbalanceLinkedAccounts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee41() {
    return _regenerator.default.wrap(function _callee41$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            return _context47.abrupt("return", getActiveLinkedAccounts().then(function (accounts) {
              return (0, _filter.default)(accounts).call(accounts, function (account) {
                return account.primaryProduct === 'samba';
              });
            }));

          case 1:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee41);
  }));
  return _getActiveOnbalanceLinkedAccounts.apply(this, arguments);
}

function getAllOnbalanceLinkedAccounts() {
  return _getAllOnbalanceLinkedAccounts.apply(this, arguments);
}

function _getAllOnbalanceLinkedAccounts() {
  _getAllOnbalanceLinkedAccounts = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee42() {
    return _regenerator.default.wrap(function _callee42$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            return _context48.abrupt("return", getLinkedAccounts().then(function (accounts) {
              return (0, _filter.default)(accounts).call(accounts, function (account) {
                return account.primaryProduct === 'samba';
              });
            }));

          case 1:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee42);
  }));
  return _getAllOnbalanceLinkedAccounts.apply(this, arguments);
}
